import { render } from "./GradiantIcon.vue?vue&type=template&id=915345a0"
import script from "./GradiantIcon.vue?vue&type=script&lang=js"
export * from "./GradiantIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__